import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { Container } from 'semantic-ui-react';
import { Icon } from 'iovisit-theme/components';

const messages = defineMessages({
  starting_from: { id: 'itinerary_start_from', defaultMessage: 'Partenza da' },
  tour_length: { id: 'itinerary_tour_length', defaultMessage: 'Lunghezza' },
  duration: { id: 'itinerary_duration', defaultMessage: 'Durata' },
  suitable_for: { id: 'itinerary_suitable_for', defaultMessage: 'Adatto a' },
});

const SummaryInfos = ({ content }) => {
  const intl = useIntl();

  return (
    <Plug pluggable="leadimage-more" id="itinerary-infos">
      {(params) => {
        return (
          <Container>
            <div className="itinerary-infos">
              {params.content.starting_from && (
                <div className="info">
                  <Icon prefix="fas" icon="map-marker-alt" className="icon" />
                  <div className="title">
                    {intl.formatMessage(messages.starting_from)}
                  </div>
                  <div className="value">{params.content.starting_from}</div>
                </div>
              )}

              {params.content.tour_length && (
                <div className="info">
                  <Icon prefix="fas" icon="arrows-alt-h" className="icon" />
                  <div className="title">
                    {intl.formatMessage(messages.tour_length)}
                  </div>
                  <div className="value">{params.content.tour_length}</div>
                </div>
              )}

              {params.content.duration && (
                <div className="info">
                  <Icon prefix="far" icon="clock" className="icon" />
                  <div className="title">
                    {intl.formatMessage(messages.duration)}
                  </div>
                  <div className="value">{params.content.duration}</div>
                </div>
              )}

              {params.content.suited_to && (
                <div className="info">
                  <Icon prefix="far" icon="user" className="icon" />
                  <div className="title">
                    {intl.formatMessage(messages.suitable_for)}
                  </div>
                  <div className="value">{params.content.suited_to.title}</div>
                </div>
              )}
            </div>
          </Container>
        );
      }}
    </Plug>
  );
};

export default SummaryInfos;
